import { Component, Input, OnInit } from '@angular/core';
import { ThumbnailBuilderService } from 'src/app/dynamic-module/video-panel/service/thumbnail-builder.service';
import { IVideoViewModel } from 'src/app/dynamic-module/video-panel/video-panel.component';
import { IVideoPickerVideoData } from 'src/app/shared/interface/video-picker-data';

@Component({
  selector: 'app-info-panel-video-lightbox',
  templateUrl: './info-panel-video-lightbox.component.html',
  styleUrls: ['./info-panel-video-lightbox.component.less']
})
export class InfoPanelVideoLightboxComponent implements OnInit {
  @Input() data: any;

  isShow = false;
  videoData: IVideoViewModel;

  constructor(private thumbnailBuilder: ThumbnailBuilderService) { }

  ngOnInit() {
    this.videoData = this.prepareVm(this.data);
  }

  openLightbox() {
    this.isShow = true;
  }

  closeLightbox() {
    this.isShow = false;
  }

  private prepareVm(data: IVideoPickerVideoData): IVideoViewModel {
    if (!data) return null;

    return {
      thumbnail: this.thumbnailBuilder.create(data.thumbnail),
      title: this.data.title,
      params: `?controls=1&muted=0&autoplay=1&showinfo=0`,
      video: {
        url: data.url,
        type: data.type,
      },
      videoTitle: data.title,
    };
  }
}
